import { useState } from "react";

import {
  X,
  Landmark,
  User,
  Wallet,
  CircleDollarSign,
  CheckCircle2,
  Clock3,
  XCircle,
  ChevronDown,
} from "lucide-react";

import "../Styles/NewChequeModal.css";

const statusOptions = [
  {
    label: "Unpresented",
    icon: <Wallet size={15} />,
    className: "unpresented",
  },

  {
    label: "Deposited",
    icon: <Clock3 size={15} />,
    className: "deposited",
  },

  {
    label: "Cleared",
    icon: <CheckCircle2 size={15} />,
    className: "cleared",
  },

  {
    label: "Cancelled",
    icon: <XCircle size={15} />,
    className: "cancelled",
  },
];

const NewChequeModal = ({
  onClose,
  onSave,
}) => {

  const [statusMenuOpen, setStatusMenuOpen] =
    useState(false);

  const [cheque, setCheque] =
    useState({
      cheque_number: "",
      bank_drawn: "",
      payer: "",
      payee: "",
      amount: "",
      admin_charge: 0,

      date_posted:
        new Date()
          .toISOString()
          .split("T")[0],

      status: "Unpresented",
    });

  const handleChange = (e) => {

    const { name, value } =
      e.target;

    let updatedCheque = {
      ...cheque,
      [name]: value,
    };

    if (name === "amount") {

      const amountValue =
        parseFloat(value) || 0;

      if (amountValue <= 100000) {

        updatedCheque.admin_charge =
          2000;

      } else if (
        amountValue >= 100001
      ) {

        updatedCheque.admin_charge =
          amountValue * 0.02;

      } else {

        updatedCheque.admin_charge =
          0;
      }
    }

    setCheque(updatedCheque);
  };

  const handleStatusSelect = (
    status
  ) => {

    setCheque({
      ...cheque,
      status,
    });

    setStatusMenuOpen(false);
  };

const handleSubmit = async () => {

  if (
    !cheque.cheque_number ||
    !cheque.bank_drawn ||
    !cheque.payer ||
    !cheque.payee ||
    !cheque.amount
  ) {

    alert(
      "Please complete all required fields."
    );

    return;
  }

  const newCheque = {

    cheque_number:
      cheque.cheque_number.trim(),

    bank_drawn:
      cheque.bank_drawn.trim(),

    payer:
      cheque.payer.trim(),

    payee:
      cheque.payee.trim(),

    amount:
      parseFloat(
        cheque.amount
      ) || 0,

    admin_charge:
      parseFloat(
        cheque.admin_charge
      ) || 0,

    date_posted:
      cheque.date_posted,

    status:
      cheque.status ||
      "Unpresented",
  };

  console.log(
    "🚀 Saving cheque:",
    newCheque
  );

  try {

    await onSave(newCheque);

    onClose();

  } catch (error) {

    console.error(
      "Modal save error:",
      error
    );
  }
};

  return (

    <div className="cheque-modal-overlay">

      <div className="cheque-modal-container">

        {/* CLOSE */}

        <button
          className="close-modal-btn"
          onClick={onClose}
        >
          <X size={18} />
        </button>

        {/* HEADER */}

        <div className="cheque-modal-header">

          <div className="modal-header-pill">
            CHEQUE TRACKER
          </div>

          <h1>
            New Cheque Entry
          </h1>

          <p>
            Create and manage
            cheque transactions.
            Please Ensure Cheque Details
            are Accurate!
            
          </p>

        </div>

        {/* FORM */}

        <div className="cheque-form-grid">

          {/* ROW */}

          <div className="cheque-input-row">

            <div className="cheque-input-group">

              <label>
                Cheque Number
              </label>

              <div className="modern-input-wrapper">

                <Wallet size={18} />

                <input
                  type="text"
                  name="cheque_number"
                  value={
                    cheque.cheque_number
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Enter cheque number"
                />

              </div>

            </div>

            <div className="cheque-input-group">

              <label>
                Bank Drawn
              </label>

              <div className="modern-input-wrapper">

                <Landmark size={18} />

                <input
                  type="text"
                  name="bank_drawn"
                  value={
                    cheque.bank_drawn
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Enter bank name"
                />

              </div>

            </div>

          </div>

          {/* ROW */}

          <div className="cheque-input-row">

            <div className="cheque-input-group">

              <label>
                Payer
              </label>

              <div className="modern-input-wrapper">

                <User size={18} />

                <input
                  type="text"
                  name="payer"
                  value={
                    cheque.payer
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Enter payer"
                />

              </div>

            </div>

            <div className="cheque-input-group">

              <label>
                Payee
              </label>

              <div className="modern-input-wrapper">

                <User size={18} />

                <input
                  type="text"
                  name="payee"
                  value={
                    cheque.payee
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="Enter payee"
                />

              </div>

            </div>

          </div>

          {/* ROW */}

          <div className="cheque-input-row">

            <div className="cheque-input-group">

              <label>
                Amount
              </label>

              <div className="modern-input-wrapper">

                <CircleDollarSign size={18} />

                <input
                  type="number"
                  name="amount"
                  value={
                    cheque.amount
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="0.00"
                />

              </div>

            </div>

            <div className="cheque-input-group">

              <label>
                Admin Charge
              </label>

              <div className="modern-input-wrapper readonly">

                <CircleDollarSign size={18} />

                <input
                  type="number"
                  name="admin_charge"
                  value={
                    cheque.admin_charge
                  }
                  readOnly
                />

              </div>

            </div>

          </div>

          {/* STATUS */}

          <div className="cheque-input-group">

            <label>
              Status
            </label>

            <div
              className="modal-status-wrapper"
            >

              <button
                className={`modal-status-pill ${cheque.status.toLowerCase()}`}
                onClick={() =>
                  setStatusMenuOpen(
                    !statusMenuOpen
                  )
                }
                type="button"
              >

                <div className="modal-status-left">

                  {
                    statusOptions.find(
                      (s) =>
                        s.label ===
                        cheque.status
                    )?.icon
                  }

                  <span>
                    {cheque.status}
                  </span>

                </div>

                <ChevronDown
                  size={16}
                />

              </button>

              {statusMenuOpen && (

                <div className="modal-status-menu">

                  {statusOptions.map(
                    (status) => (

                      <button
                        key={
                          status.label
                        }
                        type="button"
                        className={
                          status.className
                        }
                        onClick={() =>
                          handleStatusSelect(
                            status.label
                          )
                        }
                      >

                        <div className="modal-status-left">

                          {status.icon}

                          <span>
                            {
                              status.label
                            }
                          </span>

                        </div>

                      </button>
                    )
                  )}

                </div>
              )}

            </div>

          </div>

        </div>

        {/* FOOTER */}

        <div className="cheque-modal-footer">

          <button
            className="modal-btn secondary"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="modal-btn primary"
            onClick={handleSubmit}
          >
            Save Cheque
          </button>

        </div>

      </div>

    </div>
  );
};

export default NewChequeModal;